import { batteryApiErrorMessage, errorBody } from "./battery-financing-errors"

export const BATTERY_SUNGAGE_IDEMPOTENCY_CONFLICT = `BATTERY_SUNGAGE_IDEMPOTENCY_CONFLICT`
export const BATTERY_SUNGAGE_UNCERTAIN = `BATTERY_SUNGAGE_UNCERTAIN`
export const BATTERY_SUNGAGE_WITHDRAWN = `BATTERY_SUNGAGE_WITHDRAWN`
export const BATTERY_SUNGAGE_FUNDED = `BATTERY_SUNGAGE_FUNDED`
export const BATTERY_APPLICATION_CLAIM_HELD = `BATTERY_APPLICATION_CLAIM_HELD`
export const BATTERY_FINANCING_LOCKED_CODE = `BATTERY_FINANCING_LOCKED`

export const sungageApplicationErrorCode = (error: unknown): string | null => {
  const code = errorBody(error)?.error
  return typeof code === `string` && code.length > 0 ? code : null
}

/**
 * Seller-facing recovery copy. Provider payloads stay out of the UI.
 */
export const sungageApplicationErrorMessage = (error: unknown): string => {
  const code = sungageApplicationErrorCode(error)
  switch (code) {
    case BATTERY_SUNGAGE_UNCERTAIN:
      return `Sungage project identity is not confirmed. Contact support before retrying.`
    case BATTERY_SUNGAGE_WITHDRAWN:
      return `This Existing Loan Application has been withdrawn.`
    case BATTERY_SUNGAGE_FUNDED:
      return `Signed or funded financing cannot be withdrawn in Vision.`
    case BATTERY_APPLICATION_CLAIM_HELD:
      return `Another Battery-Only Proposal on this project already has an ongoing Loan Application.`
    case BATTERY_FINANCING_LOCKED_CODE:
      return `An approved Sungage Loan Application locks financing-affecting edits.`
    case BATTERY_SUNGAGE_IDEMPOTENCY_CONFLICT:
      return `This application attempt is already in use. Refresh status and continue from there.`
    default: {
      const fromServer = batteryApiErrorMessage(error)
      if (fromServer != null) {
        return fromServer
      }
      return `Unable to reach Sungage right now. The last saved application is unchanged.`
    }
  }
}
